<ng-container *ngIf="data$ | async as data">
  <div class="title-bar">
    <h1>{{ data.companyName }} adatlap</h1>
  </div>
  <div class="d-flex gap-4">
    <div [fxFlex]="50">
      <label>Cég hivatalos neve:</label>
      <p>{{ data.companyName }}</p>
    </div>
    <div [fxFlex]="50">
      <label>Cég (Brand) elnevezése:</label>
      <p>{{ data.brandName }}</p>
    </div>
  </div>

  <label>Cég adószáma:</label>
  <p>{{ data.taxNumber }}</p>
  <label class="catergory">Elérhetőség:</label>
  <div class="d-flex gap-3">
    <label class="inline">E-mail:</label>
    <p>{{ data.email }}</p>
  </div>
  <div class="d-flex gap-3">
    <label class="inline">Tel.:</label>
    <p>{{ data.phoneNumber ?? "-" }}</p>
  </div>
</ng-container>
